export const ROUTES = {
  HOME: '/',
  ADMIN_LOGIN: '/adminLogin',
  CHAT: '/chat'
}
